import styled from 'styled-components';

import { Row, colors, Tag } from '@dexma/ui-components';
import { headerHeight } from 'adapter/in/dashboards/pages/globalStyles';

export const StyledDashboardHeader = styled(Row)`
    height: ${headerHeight};
    border-bottom: 1px solid #c9cccf;
    background-color: ${colors.gray100};
    .menu-settings {
        text-align: right;
    }
    .menu-dashboard {
        display: flex;
        align-items: center;
        .name {
            padding-left: 5px;
            color: ${colors.gray700};
        }
    }
`;

export const StyledTagPinDashboard = styled(Tag)`
    margin-top: 6px;
    margin-left: 2.5rem;
`;
